<template>
    <div class="body-content">
        <h1>{{this.h1Title}}</h1>
        <ir-slider>
            <div class="content">
                <slot></slot>
            </div>
        </ir-slider>
    </div>
</template>

<script>
import IrSlider from './IrSlider'

export default {
  props: ['h1Title'],
  components: {
    IrSlider
  }
}
</script>

<style scoped>
.body-content{
    width: calc(100% - 58px - 18px);
    height: calc(100% - 42px - 35px);
    background: #F7F8F9;
    position: relative;
    padding: 42px 58px 35px 18px;
}
.body-content h1{
    width: 100%;
    height: 37px;
    text-align: left;
    font: Bold 26px/21px Microsoft YaHei;
    letter-spacing: 0;
    color: rgba(0,0,0,.85);
    padding-bottom: 24px;
}
.content{
    width: 100%;
    height: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #354ECE14;
    border-radius: 5px;
    opacity: 1;
}
  .el-scrollbar{
    height: calc(100% - 37px - 24px);
  }
  .el-scrollbar /deep/ .el-scrollbar__wrap{
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/PgMainShell.vue